module.exports = __webpack_public_path__ + "logo.png?9e74f43594c36268b034b353a094e519";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 36
// module chunks = 0